/**
 * @generated SignedSource<<765fb732c9ab99f1d776e3a535bfcf52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizViewModeSwitch_theme",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "Theme",
  "abstractKey": null
};

node.hash = "818546ce5b5cfdf4d4c54e3bf4dedd4f";

module.exports = node;
